module.exports = __webpack_public_path__ + "img/fa-brands-400.22d4787.svg";